import { Tab } from '@material-ui/core';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { useStyles } from '@webapps/styles';

import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import Annonces from './components/Annonces';
import Candidats from './components/Candidats';
import KPIBusiness from './components/KPIBusiness';
import { getInfosDashboard } from '@webapps/business';
import PartnerIcon from 'components/Icons/PartnerIcon';

import {
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { Cancel, CheckCircle, Group, PauseCircleFilled, Visibility, PersonAdd } from '@material-ui/icons';
import CvTheque from 'components/Icons/CvTheque';
import SearchOffIcon from 'components/Icons/SearchOffIcon';

const AnnoncesCandidats = () => {
  const {
    classes,
    css,
    global,
    theme: { spacing },
  } = useStyles(styles);
  const [value, setValue] = useState('1');
  const intl = useIntl();
  const location = useLocation();
  const state = location.state;
  const { idUser } = useAuth();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (state && state.route && state.route === 'candidats') {
      setValue('2');
    }
  }, []);

  const [annonceLength, setAnnonceLength] = useState(0);
  const [candidatLength, setCandidatLength] = useState(0);

  const handleAnnonceLength = (length) => {
    setAnnonceLength(length);
  };

  const handleCandidatLength = (length) => {
    setCandidatLength(length);
  };

  const [variant, setVariant] = useState(
    window.innerWidth < 768 ? 'fullWidth' : 'standard'
  );

  useEffect(() => {
    const handleResize = () => {
      setVariant(window.innerWidth < 768 ? 'fullWidth' : 'standard');
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const {
    data: dashboardInfo = {},
    refetch,
  } = useQuery(getInfosDashboard, {
    key: 'infoDashboardBusiness',
    variables: { id: idUser },
  });

  const kpiData = [
    { label: 'Étudiants', value: dashboardInfo?.studentStats?.totalStudents, icon: Group },
    { label: 'Étudiants sans entreprise', value: dashboardInfo?.studentStats?.totalStudents - dashboardInfo?.studentStats?.workStudyStudents, icon: Cancel },
    { label: 'Étudiants avec entreprise', value: dashboardInfo?.studentStats?.workStudyStudents, icon: CheckCircle },
    { label: 'Contrats à envoyer', value: dashboardInfo?.contractStats?.contractsToSend, icon: CvTheque },
  ];

  return (
    <div className={classes.container}>

      {
        value === '1' && <KPIBusiness data={[
          { label: 'Offres ouvertes', icon: CheckCircle, value: dashboardInfo?.jobStats?.openedOffers },
          { label: 'Offres fermées', icon: Cancel, value: dashboardInfo?.jobStats?.closedOffers },
          { label: 'Candidatures', icon: FindInPageIcon, value: dashboardInfo?.applicationStats?.allApplications },
          { label: 'Vues des offres', icon: Visibility, value: dashboardInfo?.viewsStats?.offersViews },
        ]} />
      }
      {
        value === '2' && <KPIBusiness data={[
          { label: 'Candidatures', icon: FindInPageIcon, value: dashboardInfo?.applicationStats?.allApplications },
          { label: 'Statuts en attentes', icon: PauseCircleFilled, value: dashboardInfo?.applicationStats?.pendingApplications },
          { label: 'Profils non examinés', icon: SearchOffIcon, value: dashboardInfo?.applicationStats?.isNotReadApplications },
          { label: 'Candidatures acceptées', icon: CheckCircle, value: dashboardInfo?.applicationStats?.acceptedApplications },
        ]} />
      }

      <div className={classes.paper} square="true">
        <TabContext value={value}>
          <TabList
            indicatorColor="undefined"
            onChange={handleChange}
            variant={variant}
          >
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '1' ? 'white' : '#F3F7FF',
                  color: value === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '1' ? 600 : 400,
                  minWidth: '12vw',
                }),
              }}
              className={global.mainTitle}
              label={'Emplois'}
              value="1"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '2' ? 'white' : '#F3F7FF',
                  color: value === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '2' ? 600 : 400,
                  minWidth: '12vw',
                }),
              }}
              className={global.mainTitle}
              label={`Candidats`}
              value="2"
            />
          </TabList>
          <div>
            <TabPanel
              className={css({
                padding: '20px',
                background: 'white',
                borderRadius: '0 10px 10px 10px',
                minHeight: !annonceLength && 'calc(100vh - 75px - 93px)',
                // maxHeight: 'calc(100vh - 75px - 93px)',
                '@media screen and (max-width: 1023px)': {
                  maxHeight: '100%',
                },
                '@media screen and (max-width: 768px)': {
                  height: '100%',
                },
              })}
              value="1"
            >
              <Annonces handleAnnonceLength={handleAnnonceLength} />
            </TabPanel>
            <TabPanel
              className={css({
                padding: '20px',
                background: 'white',
                borderRadius: '0 10px 10px 10px',
                minHeight: !candidatLength && 'calc(100vh - 75px - 93px)',
                // maxHeight: 'calc(100vh - 75px - 93px)',
                '@media screen and (max-width: 1023px)': {
                  maxHeight: '100%',
                },
                '@media screen and (max-width: 768px)': {
                  height: '100%',
                },
              })}
              value="2"
            >
              <Candidats handleCandidatLength={handleCandidatLength} />
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    // height: '100%',
        padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    fontSize: '13.5000px',
    fontWeight: 400,
    color: '#5D75A8',
    lineHeight: '110%',
    '@media (max-width:768px)': { padding: '20px' },


  },
  paper: {
    flex: '1 1 0px',
    borderRadius: 10,
  },
});

export default AnnoncesCandidats;
